import React from 'react';
import ReactDOM from 'react-dom';
import { DeterministicView } from '@bingads-webui/deterministic-view';
import { AdStrengthView } from './ad-strength-view';

export class ResponsiveSearchAdStrengthView extends DeterministicView {
  initialize({
    adId,
    edm,
    i18n,
    jsdata,
    scope,
    viewModel,
    isForVNext,
    inlineSuggestionsEnabled,
    appState,
    token,
    odataPath,
  }) {
    super.initialize();

    this.viewRef = React.createRef();
    this.view = (
      <AdStrengthView
        ref={this.viewRef}
        adId={adId}
        edm={edm}
        i18n={i18n}
        jsdata={jsdata}
        scope={scope}
        viewModel={viewModel}
        isForVNext={isForVNext}
        inlineSuggestionsEnabled={inlineSuggestionsEnabled}
        appState={appState}
        token={token}
        odataPath={odataPath}
      />
    );
  }

  setState(state) {
    if (this.viewRef.current) {
      this.viewRef.current.setState(state);
    }
    return this;
  }

  renderTrunk() {
    ReactDOM.render(this.view, this.el);
    return this;
  }

  remove() {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}
